import { getAuthAxiosBackend } from "../helpers/axios"

class newIdentificationCardServices{

    get(id){
        return getAuthAxiosBackend().get('NewIdentificationCards/getNewIdentificationCards/' + id.toString())
    }

    getByPersonId(personId){
        return getAuthAxiosBackend().get('NewIdentificationCards/getNewIdentificationCardsByPersonId/' + personId)
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('NewIdentificationCards/all', {params: data})
    }

    add(data){
        return getAuthAxiosBackend().post('NewIdentificationCards/addNewIdentificationCards', data)
    }

    edit(id, data){
        return getAuthAxiosBackend().put('NewIdentificationCards/updateNewIdentificationCards/' + id, data)
    }

    delete(id){
        return getAuthAxiosBackend().delete('NewIdentificationCards/softDeleteNewIdentificationCards/' + id.toString())
    }
}

export default new newIdentificationCardServices()